import React from 'react';
import { KpiGrid, type KpiItem } from '@/components/ui/KpiGrid';
import {
  Users,
  UserCheck,
  Plane,
  TrendingUp,
  AlertTriangle,
  UserPlus
} from 'lucide-react';

export function UsersKpiDashboard() {
  const usersKpis: KpiItem[] = [
    {
      title: 'Tổng nhân sự',
      value: 1240,
      suffix: 'Người',
      icon: Users,
      color: 'text-blue-600',
      bg: 'bg-blue-50',
      trend: 'up',
      trendValue: 'Tuyển dụng',
      chartColor: 'bg-blue-500',
      chartData: [1200, 1210, 1220, 1225, 1230, 1235, 1240]
    },
    {
      title: 'Tỷ lệ có mặt',
      value: 96.5,
      suffix: '%',
      icon: UserCheck,
      color: 'text-emerald-600',
      bg: 'bg-emerald-50',
      trend: 'up',
      trendValue: 'Hôm nay',
      chartColor: 'bg-emerald-500',
      chartData: [95, 94, 96, 95.5, 96, 96.5, 96.5]
    },
    {
      title: 'Nhân sự nghỉ phép',
      value: 24,
      suffix: 'Người',
      icon: Plane,
      color: 'text-amber-600',
      bg: 'bg-amber-50',
      trend: 'down',
      trendValue: 'Tuần này',
      chartColor: 'bg-amber-500',
      chartData: [30, 28, 25, 26, 25, 24, 24]
    },
    {
      title: 'Hiệu suất TB',
      value: 92,
      suffix: 'Điểm',
      icon: TrendingUp,
      color: 'text-teal-600',
      bg: 'bg-teal-50',
      trend: 'up',
      trendValue: 'Tháng này',
      chartColor: 'bg-teal-500',
      chartData: [88, 89, 90, 91, 91.5, 92, 92]
    },
    {
      title: 'Tuyển dụng mới',
      value: 15,
      suffix: 'Người',
      icon: UserPlus,
      color: 'text-indigo-600',
      bg: 'bg-indigo-50',
      trend: 'neutral',
      trendValue: 'Tháng này',
      chartColor: 'bg-indigo-500',
      chartData: [10, 12, 12, 14, 14, 15, 15]
    },
    {
      title: 'Cảnh báo vi phạm',
      value: 3,
      suffix: 'Vụ việc',
      icon: AlertTriangle,
      color: 'text-rose-600',
      bg: 'bg-rose-50',
      trend: 'down',
      trendValue: 'Kỷ luật',
      chartColor: 'bg-rose-500',
      chartData: [5, 4, 4, 3, 3, 3, 3]
    }
  ];

  return <KpiGrid kpis={usersKpis} />;
}
